import MainScene from "src/app/Scenes/MainScene";
import { LatLonToXYConverter } from "./LatLonToXY";
import { Place, PlacesList } from './dataClasses/Places';
import { FueFolletMetadata } from "./dataClasses/FueFolletMappings";


export class FueFollet{

    scene: MainScene;
    startingPlace: Place;
    startingPoint: Phaser.Geom.Point;
    endingPlace: Place;
    endingPoint: Phaser.Geom.Point;
    tokenPrerequisite?: string;
    animation?: string;
    prerequisiteMet: boolean;
    noLongerNeeded: boolean = false;
    finalDestination: boolean = false;
    distanceBetweenPoints: number;
    entity: Phaser.GameObjects.Particles.ParticleEmitter | Phaser.GameObjects.Sprite;
    speed: number;
    interpolatedPoint: Phaser.Geom.Point;
    time: number = 0;
    deltaT: number;

    static preload(scene: Phaser.Scene){
        scene.load.atlas('flares', 'assets/particles/flares.png', 'assets/particles/flares.json');
    }

    constructor( scene: MainScene, metadata: FueFolletMetadata){

        // , startingPlaceName: string, endingPlaceName: string, tokenPrerequisite?: string, animation?: string, scale? : number
        this.scene = scene;
        this.tokenPrerequisite = metadata.tokenPrerequisite;
        this.finalDestination = metadata.finalDestination ? metadata.finalDestination : false;
        this.animation = metadata.animation;

        // Initially assume that if there is a pre-requisite, it is not satisfied yet
        this.prerequisiteMet = !metadata.tokenPrerequisite;
        this.startingPlace = PlacesList.find((p) => {return p.name === metadata.startingPlace});
        this.endingPlace = PlacesList.find((p) => {return p.name === metadata.endingPlace});

        this.startingPoint = LatLonToXYConverter.latlngToScreenXY(
            this.startingPlace.coords.latitude,
            this.startingPlace.coords.longitude
        );

        const height = this.scene.textures.get(this.startingPlace.imageName).getSourceImage().height;
        this.startingPoint.y += height/4;

        this.startingPoint.x += metadata.xOffset ? metadata.xOffset : 0;
        this.startingPoint.y += metadata.yOffset ? metadata.yOffset : 0;

        this.endingPoint = LatLonToXYConverter.latlngToScreenXY(
            this.endingPlace.coords.latitude,
            this.endingPlace.coords.longitude
        );

        this.distanceBetweenPoints = Math.sqrt((this.startingPoint.x - this.endingPoint.x)**2 + (this.startingPoint.y - this.endingPoint.y)**2);

        // this.graphics = scene.add.graphics({ lineStyle: { width: 3, color: 0x2266aa }, fillStyle: { color: 0x2266aa } });
        // const line = this.graphics.lineBetween(this.startingPoint.x, this.startingPoint.y, this.endingPoint.x, this.endingPoint.y);
        // line.setDepth(4);

        this.interpolatedPoint = Phaser.Geom.Point.Interpolate(this.startingPoint, this.endingPoint, this.time);

        if(this.animation){
            this.entity = this.scene.add.sprite(
                this.startingPoint.x,
                (this.startingPoint.y),
                "gouhl"
            )
            this.entity.flipX = true;
            this.entity.anims.play(this.animation, true);
        }
        else{
            this.entity = this.scene.add.particles(this.startingPoint.x, (this.startingPoint.y), 'flares',
                {
                    frame: 'blue',
                    color: [ 0x040d61, 0x937ef3 ],
                    colorEase: 'quad.out',
                    lifespan: 1200,
                    angle: { min: -180, max: 180 },
                    scale: { start: 0.35, end: 0, ease: 'sine.out' },
                    speed: 75,
                    advance: 1000,
                    blendMode: 'ADD'
                }
            );
        }

        this.entity.setDepth(2);
        this.entity.setVisible(false);
        this.entity.setActive(false);
        metadata.scale && this.entity.setScale(metadata.scale)
    }
    
    checkPrerequisiteMet(){
        this.prerequisiteMet = MainScene.tokens.includes(this.tokenPrerequisite);
    }

    checkNoLongerNeeded(){
        const endPointDefeated = MainScene.tokens.includes(this.endingPlace.name);
        this.noLongerNeeded = this.prerequisiteMet && endPointDefeated;
    }

    update(){

        // Calculate distance between player and follower
        const playerPosition = this.scene.player.position;
        const playerDistance = Phaser.Math.Distance.Between(
            playerPosition.x, playerPosition.y,
            this.entity.x, this.entity.y
        );

        // If this fue follet is no longer needed, hide it and stop updating
        this.checkNoLongerNeeded();
        if(this.noLongerNeeded){
            this.entity.setActive(false);
            this.entity.setVisible(false);
            return;
        }
        
        // check if prerequisites are met, if so display and move the fue follet
        if(this.prerequisiteMet){

                this.entity.setActive(true);
                this.entity.setVisible(true);

                if(playerDistance < 120){
                    // Compute how far the player has progressed along the path (optional)
                    const totalPathLength = Phaser.Math.Distance.BetweenPoints(this.startingPoint, this.endingPoint);
                    const entityProgress = this.time * totalPathLength;
                    const playerProgress = Phaser.Math.Distance.BetweenPoints(this.startingPoint, { x: playerPosition.x, y: playerPosition.y });

                    // Clamp entity so player can't overtake
                    if (playerProgress >= entityProgress - 100) {
                        const safeProgress = (playerProgress + 50) / totalPathLength;
                        this.time = safeProgress % 1;
                    }
                    Phaser.Geom.Point.Interpolate(this.startingPoint, this.endingPoint, this.time, this.interpolatedPoint);
                    this.entity.setX(this.interpolatedPoint.x);
                    this.entity.setY(this.interpolatedPoint.y);
                }
            }
            else{
                this.checkPrerequisiteMet();
            }
    }
}